import { ComponentType, FunctionComponent } from 'react';
import {
  Redirect,
  Route,
  RouteComponentProps,
  RouteProps,
  useHistory,
} from 'react-router';

import { storageService } from 'services/storage/storage';

import { ROUTES } from 'constants/routes';

interface IPrivateRouteProps extends RouteProps {
  component: ComponentType<RouteComponentProps> | ComponentType;
  redirectTo?: string;
}

export const PrivateRoute: FunctionComponent<IPrivateRouteProps> = ({
  component: Component,
  redirectTo,
  ...rest
}) => {
  const { location } = useHistory();

  const isToken = storageService.getToken();

  if (!isToken && location.pathname === ROUTES.main) {
    return (
      <Redirect
        push
        to={{
          pathname: redirectTo || ROUTES.welcome,
          state: { from: location },
        }}
      />
    );
  }

  if (!isToken) {
    return (
      <Redirect
        push
        to={{
          pathname: redirectTo || ROUTES.signUp,
          state: { from: location },
        }}
      />
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderRoute = (props: any) => <Component {...props} />;

  return <Route {...rest} render={renderRoute} />;
};
